import flag_ac from "./assets/ac.svg";
import flag_ad from "./assets/ad.svg";
import flag_ae from "./assets/ae.svg";
import flag_af from "./assets/af.svg";
import flag_ag from "./assets/ag.svg";
import flag_ai from "./assets/ai.svg";
import flag_al from "./assets/al.svg";
import flag_am from "./assets/am.svg";
import flag_ao from "./assets/ao.svg";
import flag_aq from "./assets/aq.svg";
import flag_ar from "./assets/ar.svg";
import flag_as from "./assets/as.svg";
import flag_at from "./assets/at.svg";
import flag_au from "./assets/au.svg";
import flag_aw from "./assets/aw.svg";
import flag_ax from "./assets/ax.svg";
import flag_az from "./assets/az.svg";
import flag_ba from "./assets/ba.svg";
import flag_bb from "./assets/bb.svg";
import flag_bd from "./assets/bd.svg";
import flag_be from "./assets/be.svg";
import flag_bf from "./assets/bf.svg";
import flag_bg from "./assets/bg.svg";
import flag_bh from "./assets/bh.svg";
import flag_bi from "./assets/bi.svg";
import flag_bj from "./assets/bj.svg";
import flag_bl from "./assets/bl.svg";
import flag_bm from "./assets/bm.svg";
import flag_bn from "./assets/bn.svg";
import flag_bo from "./assets/bo.svg";
import flag_bq from "./assets/bq.svg";
import flag_br from "./assets/br.svg";
import flag_bs from "./assets/bs.svg";
import flag_bt from "./assets/bt.svg";
import flag_bv from "./assets/bv.svg";
import flag_bw from "./assets/bw.svg";
import flag_by from "./assets/by.svg";
import flag_bz from "./assets/bz.svg";
import flag_ca from "./assets/ca.svg";
import flag_cc from "./assets/cc.svg";
import flag_cd from "./assets/cd.svg";
import flag_cefta from "./assets/cefta.svg";
import flag_cf from "./assets/cf.svg";
import flag_cg from "./assets/cg.svg";
import flag_ch from "./assets/ch.svg";
import flag_ci from "./assets/ci.svg";
import flag_ck from "./assets/ck.svg";
import flag_cl from "./assets/cl.svg";
import flag_cm from "./assets/cm.svg";
import flag_cn from "./assets/cn.svg";
import flag_co from "./assets/co.svg";
import flag_cp from "./assets/cp.svg";
import flag_cr from "./assets/cr.svg";
import flag_cu from "./assets/cu.svg";
import flag_cv from "./assets/cv.svg";
import flag_cw from "./assets/cw.svg";
import flag_cx from "./assets/cx.svg";
import flag_cy from "./assets/cy.svg";
import flag_cz from "./assets/cz.svg";
import flag_de from "./assets/de.svg";
import flag_dg from "./assets/dg.svg";
import flag_dj from "./assets/dj.svg";
import flag_dk from "./assets/dk.svg";
import flag_dm from "./assets/dm.svg";
import flag_do from "./assets/do.svg";
import flag_dz from "./assets/dz.svg";
import flag_ea from "./assets/ea.svg";
import flag_ec from "./assets/ec.svg";
import flag_ee from "./assets/ee.svg";
import flag_eg from "./assets/eg.svg";
import flag_eh from "./assets/eh.svg";
import flag_er from "./assets/er.svg";
import flag_es from "./assets/es.svg";
import flag_es_ct from "./assets/es-ct.svg";
import flag_es_ga from "./assets/es-ga.svg";
import flag_et from "./assets/et.svg";
import flag_eu from "./assets/eu.svg";
import flag_fi from "./assets/fi.svg";
import flag_fj from "./assets/fj.svg";
import flag_fk from "./assets/fk.svg";
import flag_fm from "./assets/fm.svg";
import flag_fo from "./assets/fo.svg";
import flag_fr from "./assets/fr.svg";
import flag_ga from "./assets/ga.svg";
import flag_gb from "./assets/gb.svg";
import flag_gb_nir from "./assets/gb-nir.svg";
import flag_gb_sct from "./assets/gb-sct.svg";
import flag_gb_wls from "./assets/gb-wls.svg";
import flag_gd from "./assets/gd.svg";
import flag_ge from "./assets/ge.svg";
import flag_gf from "./assets/gf.svg";
import flag_gg from "./assets/gg.svg";
import flag_gh from "./assets/gh.svg";
import flag_gi from "./assets/gi.svg";
import flag_gl from "./assets/gl.svg";
import flag_gm from "./assets/gm.svg";
import flag_gn from "./assets/gn.svg";
import flag_gp from "./assets/gp.svg";
import flag_gq from "./assets/gq.svg";
import flag_gr from "./assets/gr.svg";
import flag_gs from "./assets/gs.svg";
import flag_gt from "./assets/gt.svg";
import flag_gu from "./assets/gu.svg";
import flag_gw from "./assets/gw.svg";
import flag_gy from "./assets/gy.svg";
import flag_hk from "./assets/hk.svg";
import flag_hm from "./assets/hm.svg";
import flag_hn from "./assets/hn.svg";
import flag_hr from "./assets/hr.svg";
import flag_ht from "./assets/ht.svg";
import flag_hu from "./assets/hu.svg";
import flag_ic from "./assets/ic.svg";
import flag_id from "./assets/id.svg";
import flag_ie from "./assets/ie.svg";
import flag_il from "./assets/il.svg";
import flag_im from "./assets/im.svg";
import flag_in from "./assets/in.svg";
import flag_io from "./assets/io.svg";
import flag_iq from "./assets/iq.svg";
import flag_ir from "./assets/ir.svg";
import flag_is from "./assets/is.svg";
import flag_it from "./assets/it.svg";
import flag_je from "./assets/je.svg";
import flag_jm from "./assets/jm.svg";
import flag_jo from "./assets/jo.svg";
import flag_jp from "./assets/jp.svg";
import flag_ke from "./assets/ke.svg";
import flag_kg from "./assets/kg.svg";
import flag_kh from "./assets/kh.svg";
import flag_ki from "./assets/ki.svg";
import flag_km from "./assets/km.svg";
import flag_kn from "./assets/kn.svg";
import flag_kp from "./assets/kp.svg";
import flag_kr from "./assets/kr.svg";
import flag_kw from "./assets/kw.svg";
import flag_ky from "./assets/ky.svg";
import flag_kz from "./assets/kz.svg";
import flag_la from "./assets/la.svg";
import flag_lb from "./assets/lb.svg";
import flag_lc from "./assets/lc.svg";
import flag_li from "./assets/li.svg";
import flag_lk from "./assets/lk.svg";
import flag_lr from "./assets/lr.svg";
import flag_ls from "./assets/ls.svg";
import flag_lt from "./assets/lt.svg";
import flag_lu from "./assets/lu.svg";
import flag_lv from "./assets/lv.svg";
import flag_ly from "./assets/ly.svg";
import flag_ma from "./assets/ma.svg";
import flag_mc from "./assets/mc.svg";
import flag_md from "./assets/md.svg";
import flag_me from "./assets/me.svg";
import flag_mf from "./assets/mf.svg";
import flag_mg from "./assets/mg.svg";
import flag_mh from "./assets/mh.svg";
import flag_mk from "./assets/mk.svg";
import flag_ml from "./assets/ml.svg";
import flag_mm from "./assets/mm.svg";
import flag_mn from "./assets/mn.svg";
import flag_mo from "./assets/mo.svg";
import flag_mp from "./assets/mp.svg";
import flag_mq from "./assets/mq.svg";
import flag_mr from "./assets/mr.svg";
import flag_ms from "./assets/ms.svg";
import flag_mt from "./assets/mt.svg";
import flag_mu from "./assets/mu.svg";
import flag_mv from "./assets/mv.svg";
import flag_mw from "./assets/mw.svg";
import flag_mx from "./assets/mx.svg";
import flag_my from "./assets/my.svg";
import flag_mz from "./assets/mz.svg";
import flag_na from "./assets/na.svg";
import flag_nc from "./assets/nc.svg";
import flag_ne from "./assets/ne.svg";
import flag_nf from "./assets/nf.svg";
import flag_ng from "./assets/ng.svg";
import flag_ni from "./assets/ni.svg";
import flag_nl from "./assets/nl.svg";
import flag_no from "./assets/no.svg";
import flag_np from "./assets/np.svg";
import flag_nr from "./assets/nr.svg";
import flag_nu from "./assets/nu.svg";
import flag_nz from "./assets/nz.svg";
import flag_om from "./assets/om.svg";
import flag_pa from "./assets/pa.svg";
import flag_pe from "./assets/pe.svg";
import flag_pf from "./assets/pf.svg";
import flag_pg from "./assets/pg.svg";
import flag_ph from "./assets/ph.svg";
import flag_pk from "./assets/pk.svg";
import flag_pl from "./assets/pl.svg";
import flag_pm from "./assets/pm.svg";
import flag_pn from "./assets/pn.svg";
import flag_pr from "./assets/pr.svg";
import flag_ps from "./assets/ps.svg";
import flag_pt from "./assets/pt.svg";
import flag_pw from "./assets/pw.svg";
import flag_py from "./assets/py.svg";
import flag_qa from "./assets/qa.svg";
import flag_re from "./assets/re.svg";
import flag_ro from "./assets/ro.svg";
import flag_rs from "./assets/rs.svg";
import flag_ru from "./assets/ru.svg";
import flag_rw from "./assets/rw.svg";
import flag_sa from "./assets/sa.svg";
import flag_sb from "./assets/sb.svg";
import flag_sc from "./assets/sc.svg";
import flag_sd from "./assets/sd.svg";
import flag_se from "./assets/se.svg";
import flag_sg from "./assets/sg.svg";
import flag_sh from "./assets/sh.svg";
import flag_si from "./assets/si.svg";
import flag_sj from "./assets/sj.svg";
import flag_sk from "./assets/sk.svg";
import flag_sl from "./assets/sl.svg";
import flag_sm from "./assets/sm.svg";
import flag_sn from "./assets/sn.svg";
import flag_so from "./assets/so.svg";
import flag_sr from "./assets/sr.svg";
import flag_ss from "./assets/ss.svg";
import flag_st from "./assets/st.svg";
import flag_sv from "./assets/sv.svg";
import flag_sx from "./assets/sx.svg";
import flag_sy from "./assets/sy.svg";
import flag_sz from "./assets/sz.svg";
import flag_ta from "./assets/ta.svg";
import flag_tc from "./assets/tc.svg";
import flag_td from "./assets/td.svg";
import flag_tf from "./assets/tf.svg";
import flag_tg from "./assets/tg.svg";
import flag_th from "./assets/th.svg";
import flag_tj from "./assets/tj.svg";
import flag_tk from "./assets/tk.svg";
import flag_tl from "./assets/tl.svg";
import flag_tm from "./assets/tm.svg";
import flag_tn from "./assets/tn.svg";
import flag_to from "./assets/to.svg";
import flag_tr from "./assets/tr.svg";
import flag_tt from "./assets/tt.svg";
import flag_tv from "./assets/tv.svg";
import flag_tw from "./assets/tw.svg";
import flag_tz from "./assets/tz.svg";
import flag_ua from "./assets/ua.svg";
import flag_ug from "./assets/ug.svg";
import flag_um from "./assets/um.svg";
import flag_un from "./assets/un.svg";
import flag_us from "./assets/us.svg";
import flag_uy from "./assets/uy.svg";
import flag_uz from "./assets/uz.svg";
import flag_va from "./assets/va.svg";
import flag_vc from "./assets/vc.svg";
import flag_ve from "./assets/ve.svg";
import flag_vg from "./assets/vg.svg";
import flag_vi from "./assets/vi.svg";
import flag_vn from "./assets/vn.svg";
import flag_vu from "./assets/vu.svg";
import flag_wf from "./assets/wf.svg";
import flag_ws from "./assets/ws.svg";
import flag_xk from "./assets/xk.svg";
import flag_xx from "./assets/xx.svg";
import flag_ye from "./assets/ye.svg";
import flag_yt from "./assets/yt.svg";
import flag_za from "./assets/za.svg";
import flag_zm from "./assets/zm.svg";
import flag_zw from "./assets/zw.svg";

const flags: Record<string, string> = {
  ac: flag_ac,
  ad: flag_ad,
  ae: flag_ae,
  af: flag_af,
  ag: flag_ag,
  ai: flag_ai,
  al: flag_al,
  am: flag_am,
  ao: flag_ao,
  aq: flag_aq,
  ar: flag_ar,
  as: flag_as,
  at: flag_at,
  au: flag_au,
  aw: flag_aw,
  ax: flag_ax,
  az: flag_az,
  ba: flag_ba,
  bb: flag_bb,
  bd: flag_bd,
  be: flag_be,
  bf: flag_bf,
  bg: flag_bg,
  bh: flag_bh,
  bi: flag_bi,
  bj: flag_bj,
  bl: flag_bl,
  bm: flag_bm,
  bn: flag_bn,
  bo: flag_bo,
  bq: flag_bq,
  br: flag_br,
  bs: flag_bs,
  bt: flag_bt,
  bv: flag_bv,
  bw: flag_bw,
  by: flag_by,
  bz: flag_bz,
  ca: flag_ca,
  cc: flag_cc,
  cd: flag_cd,
  cefta: flag_cefta,
  cf: flag_cf,
  cg: flag_cg,
  ch: flag_ch,
  ci: flag_ci,
  ck: flag_ck,
  cl: flag_cl,
  cm: flag_cm,
  cn: flag_cn,
  co: flag_co,
  cp: flag_cp,
  cr: flag_cr,
  cu: flag_cu,
  cv: flag_cv,
  cw: flag_cw,
  cx: flag_cx,
  cy: flag_cy,
  cz: flag_cz,
  de: flag_de,
  dg: flag_dg,
  dj: flag_dj,
  dk: flag_dk,
  dm: flag_dm,
  do: flag_do,
  dz: flag_dz,
  ea: flag_ea,
  ec: flag_ec,
  ee: flag_ee,
  eg: flag_eg,
  eh: flag_eh,
  er: flag_er,
  es_ct: flag_es_ct,
  es_ga: flag_es_ga,
  es: flag_es,
  et: flag_et,
  eu: flag_eu,
  fi: flag_fi,
  fj: flag_fj,
  fk: flag_fk,
  fm: flag_fm,
  fo: flag_fo,
  fr: flag_fr,
  ga: flag_ga,
  gb: flag_gb,
  gb_nir: flag_gb_nir,
  gb_sct: flag_gb_sct,
  gb_wls: flag_gb_wls,
  gd: flag_gd,
  ge: flag_ge,
  gf: flag_gf,
  gg: flag_gg,
  gh: flag_gh,
  gi: flag_gi,
  gl: flag_gl,
  gm: flag_gm,
  gn: flag_gn,
  gp: flag_gp,
  gq: flag_gq,
  gr: flag_gr,
  gs: flag_gs,
  gt: flag_gt,
  gu: flag_gu,
  gw: flag_gw,
  gy: flag_gy,
  hk: flag_hk,
  hm: flag_hm,
  hn: flag_hn,
  hr: flag_hr,
  ht: flag_ht,
  hu: flag_hu,
  ic: flag_ic,
  id: flag_id,
  ie: flag_ie,
  il: flag_il,
  im: flag_im,
  in: flag_in,
  io: flag_io,
  iq: flag_iq,
  ir: flag_ir,
  is: flag_is,
  it: flag_it,
  je: flag_je,
  jm: flag_jm,
  jo: flag_jo,
  jp: flag_jp,
  ke: flag_ke,
  kg: flag_kg,
  kh: flag_kh,
  ki: flag_ki,
  km: flag_km,
  kn: flag_kn,
  kp: flag_kp,
  kr: flag_kr,
  kw: flag_kw,
  ky: flag_ky,
  kz: flag_kz,
  la: flag_la,
  lb: flag_lb,
  lc: flag_lc,
  li: flag_li,
  lk: flag_lk,
  lr: flag_lr,
  ls: flag_ls,
  lt: flag_lt,
  lu: flag_lu,
  lv: flag_lv,
  ly: flag_ly,
  ma: flag_ma,
  mc: flag_mc,
  md: flag_md,
  me: flag_me,
  mf: flag_mf,
  mg: flag_mg,
  mh: flag_mh,
  mk: flag_mk,
  ml: flag_ml,
  mm: flag_mm,
  mn: flag_mn,
  mo: flag_mo,
  mp: flag_mp,
  mq: flag_mq,
  mr: flag_mr,
  ms: flag_ms,
  mt: flag_mt,
  mu: flag_mu,
  mv: flag_mv,
  mw: flag_mw,
  mx: flag_mx,
  my: flag_my,
  mz: flag_mz,
  na: flag_na,
  nc: flag_nc,
  ne: flag_ne,
  nf: flag_nf,
  ng: flag_ng,
  ni: flag_ni,
  nl: flag_nl,
  no: flag_no,
  np: flag_np,
  nr: flag_nr,
  nu: flag_nu,
  nz: flag_nz,
  om: flag_om,
  pa: flag_pa,
  pe: flag_pe,
  pf: flag_pf,
  pg: flag_pg,
  ph: flag_ph,
  pk: flag_pk,
  pl: flag_pl,
  pm: flag_pm,
  pn: flag_pn,
  pr: flag_pr,
  ps: flag_ps,
  pt: flag_pt,
  pw: flag_pw,
  py: flag_py,
  qa: flag_qa,
  re: flag_re,
  ro: flag_ro,
  rs: flag_rs,
  ru: flag_ru,
  rw: flag_rw,
  sa: flag_sa,
  sb: flag_sb,
  sc: flag_sc,
  sd: flag_sd,
  se: flag_se,
  sg: flag_sg,
  sh: flag_sh,
  si: flag_si,
  sj: flag_sj,
  sk: flag_sk,
  sl: flag_sl,
  sm: flag_sm,
  sn: flag_sn,
  so: flag_so,
  sr: flag_sr,
  ss: flag_ss,
  st: flag_st,
  sv: flag_sv,
  sx: flag_sx,
  sy: flag_sy,
  sz: flag_sz,
  ta: flag_ta,
  tc: flag_tc,
  td: flag_td,
  tf: flag_tf,
  tg: flag_tg,
  th: flag_th,
  tj: flag_tj,
  tk: flag_tk,
  tl: flag_tl,
  tm: flag_tm,
  tn: flag_tn,
  to: flag_to,
  tr: flag_tr,
  tt: flag_tt,
  tv: flag_tv,
  tw: flag_tw,
  tz: flag_tz,
  ua: flag_ua,
  ug: flag_ug,
  um: flag_um,
  un: flag_un,
  us: flag_us,
  uy: flag_uy,
  uz: flag_uz,
  va: flag_va,
  vc: flag_vc,
  ve: flag_ve,
  vg: flag_vg,
  vi: flag_vi,
  vn: flag_vn,
  vu: flag_vu,
  wf: flag_wf,
  ws: flag_ws,
  xk: flag_xk,
  xx: flag_xx,
  ye: flag_ye,
  yt: flag_yt,
  za: flag_za,
  zm: flag_zm,
  zw: flag_zw,
};

export type FlagCountryCode = keyof typeof flags | Uppercase<keyof typeof flags>;
export { flags };
